<template>
  <div
    v-click-outside="handleFocusOut"
    class="user-dropdown"
    tabindex="0"
  >
    <div
      v-if="!loginLoading"
      class="click-action"
      @click="controlUserDropdown"
    >
      <md-icon class="user-profile-icon">
        person_outline
      </md-icon>
      <span class="profile-name">
        <div>{{ fullNameProfile }}</div>
      </span>
      <md-icon class="arrow">
        {{ isActive ? "arrow_drop_up" : "arrow_drop_down" }}
      </md-icon>
    </div>
    <div
      v-else
      class="click-action logout"
    >
      <spinner class="loading" />
      <span class="profile-name">
        <div>Saindo...</div>
      </span>
    </div>
    <ul
      class="menu"
      :class="{ active: isActive, 'full-width': isFullwidth }"
    >
      <li @click="goTo('dados-cadastrais', 'Dados Cadastrais')">
        Dados Cadastrais
      </li>
      <li
        v-if="toggle.collectPlace"
        @click="goTo('collection-point-management', 'Posto de Coleta')"
      >
        Meus postos de coleta
      </li>
      <li
        v-if="toggle.profileExam"
        @click="goTo('exam-profiles', 'Perfis de exames')"
      >
        Meus perfis de exame
      </li>
      <li
        v-if="toggle.patientManagement"
        @click="goTo('doctor', 'Médicos')"
      >
        Médicos
      </li>
      <li @click="openPasswordModal()">
        Alterar senha
      </li>
      <li
        class="logout-link icon-header-decoration"
        @click="pushToLogout()"
      >
        <md-icon
          id="logoutIcon"
          class="logout-icon"
        >
          exit_to_app
        </md-icon>
        <span>Sair do AOL</span>
      </li>
    </ul>

    <PasswordChangeModal ref="passwordChangeModal" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import UserProfile from "../UserProfile";
import Spinner from "@/components/common/Spinner";
import PasswordChangeModal from "@/components/ProfileManagement/components/PasswordChangeModal";

import { clickOutside } from "@/utils/directives";
import { getCookie } from '@/utils/auth-utils'

export default {
  name: "UserDropdown",
  components: {
    "user-profile": UserProfile,
    Spinner,
    PasswordChangeModal,
  },
  directives: {
    "click-outside": {
      bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          // here I check that click was outside the el and his children
          if (!(el === event.target || el.contains(event.target))) {
            // and if it did, call method provided in attribute value
            vnode.context[binding.expression](event);
          }
        };
        document.body.addEventListener("click", el.clickOutsideEvent);
      },
      unbind: function (el) {
        document.body.removeEventListener("click", el.clickOutsideEvent);
      },
    },
    clickOutside,
  },
  data() {
    return {
      isActive: false,
    };
  },
  computed: {
    ...mapGetters(["loginLoading", "profile", "toggle"]),
    isFullwidth() {
      return this.fullNameProfile.length > 11;
    },
    fullNameProfile() {
      const user = this.profile;
      return user.id_laboratory + " - " + user.username;
    },
  },
  watch: {
    loginLoading(newValue) {
      if (newValue === true) {
        this.isActive = false;
      }
    },
  },
  mounted() {
    if (this.profile.temporaryPassword && !getCookie("passwordChanged")) {
      setTimeout(() => {
        this.$refs.passwordChangeModal.openPasswordChangeModal();
      }, 300);
    }
  },
  methods: {
    ...mapActions(["logout", "setComunicationSidebarShowOff"]),
    handleFocusOut() {
      if (this.isActive) {
        this.isActive = false;
      }
    },
    goTo(view, action) {
      const viewConcat = "/" + view;
      if (this.$route.path !== viewConcat) {
        this.pushEventToAnalytics(action);
        this.$router.replace(viewConcat);
      }

      setTimeout(() => {
        this.isActive = false;
      }, 300);
    },
    pushEventToAnalytics(action) {
      this.$analytics.pushAnalyticsEvent("ga-event", {
        category: "Menu superior",
        action: action,
        "id-user": this.profile.id,
        "id-lab": this.profile.id_laboratory,
        "name-lab": this.profile.laboratoryName,
      });
    },
    pushToLogout() {
      localStorage.removeItem("lastSeenPendencyAlert");
      this.logout();
      this.pushEventToAnalytics("Logout");
    },
    openPasswordModal() {
      this.$refs.passwordChangeModal.openPasswordChangeModal();

      setTimeout(() => {
        this.isActive = false;
      }, 300);
    },
    controlUserDropdown() {
      this.isActive = !this.isActive;
      this.setComunicationSidebarShowOff(false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../static/stylesheets/mixins";

.user-dropdown {
  position: relative;
  color: #4a4a4a;
  outline: none;

  @include browser-ie-11 {
    display: flex;
    flex-grow: 0;
  }

  .click-action {
    cursor: pointer;
    padding: 7px 15px;

    &.logout {
      display: flex;

      .profile-name {
        margin-left: 12px;
      }
    }

    .profile-name {
      display: inline-flex;
      margin-right: 20px;
      font-size: 14px;
      font-weight: 500;
      color: gray;
      @include browser-ie-11 {
        div {
          display: inline-block;
        }
      }
    }
    .user-profile-icon {
      color: gray;
    }
    i.arrow {
      float: right;
      color: gray;
      padding-right: 5px;
    }

    .loader {
      width: 10px;
      height: 10px;
    }
  }
  .menu {
    display: none;
    position: absolute;
    right: 0;
    background-color: #ffffff;
    margin-top: 7px;
    box-shadow: 0px 4px 5px 1px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    &.active {
      display: block;
    }
    &.full-width {
      left: 0;

      @include browser-ie-11 {
        top: 35px;
      }
    }
    li {
      &:hover {
        background-color: #f7f7f7;
        color: #000000 !important;
      }
      cursor: pointer;
      padding: 12px 19px;
      line-height: 24px;
      font-size: 14px;
      line-height: 1;
      margin: 0 !important;
      min-width: 180px;
      .logout-icon {
        color: gray;
      }
      &:hover {
        opacity: 0.88;
      }
      &:last-of-type {
        border-top: 1px solid #e0e0e0;
      }
    }
    .menu-link {
      cursor: pointer;
    }
  }
}
</style>
